import React, { Component } from 'react';
import { connect } from "react-redux";
import { FormattedMessage } from 'react-intl';
import './DetailClinic.scss'
import HomeHeader from '../../HomePage/HomeHeader';
import DoctorSchedule from '../Doctor/DoctorSchedule'
import DoctorExtraInfo from '../Doctor/DoctorExtraInfo'
import ProfileDoctors from '../Doctor/ProfileDoctors';
import { getAllDetailClinicById, getAllCodeService } from '../../../services/userService'
import _ from 'lodash';
class DetailClinic extends Component {

    constructor(props) {
        super(props);

        this.state = {
            arrDoctorId: [],
            dataDetailClinic: {},

        }
    }
    async componentDidMount() {

        if (this.props.match && this.props.match.params && this.props.match.params.id) {
            let id = this.props.match.params.id
            let res = await getAllDetailClinicById({
                id: id
            })

            if (res && res.errCode === 0) {
                let data = res.data
                let arrDoctorId = []
                if (data && !_.isEmpty(data)) {
                    let arr = data.doctorClinic
                    if (arr && arr.length > 0) {
                        arr.map(item => {
                            arrDoctorId.push(item.doctorId)
                        })
                    }
                }

                this.setState({
                    dataDetailClinic: res.data,
                    arrDoctorId: arrDoctorId,

                })
            }

        }
    }


    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.language !== prevProps.language) {

        }


    }

    render() {
        let { arrDoctorId, dataDetailClinic } = this.state
        console.log('check ', this.state);
        let { language } = this.props
        return (
            <>
                <div className='detail-specialty-container'>
                    <HomeHeader />
                    <div className='detail-specialty-body'>

                        <div className='description-specialty'>
                            {dataDetailClinic && !_.isEmpty(dataDetailClinic) &&
                                <>
                                <div>{dataDetailClinic.name}</div>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: dataDetailClinic.descriptionHTML }}
                                    />
                                </>
                            }
                        </div>

                        {arrDoctorId && arrDoctorId.length > 0 &&
                            arrDoctorId.map((item, index) => {
                                return (
                                    <div className='each-doctor' key={index}>
                                        <div className='detail-content-left'>
                                            <div className='profile-doctor'>
                                                <ProfileDoctors
                                                    doctorId={item}
                                                    isShowDescriptionDoctor={true}
                                                    isShowLinkDetail={true}
                                                    isShowPrice={false}
                                                //  dataTime={dataTime}

                                                />
                                            </div>
                                        </div>
                                        <div className='detail-content-right'>
                                            <div className='doctor-schedule'>
                                                <DoctorSchedule
                                                    doctorIdFromParent={item}

                                                />
                                            </div>
                                            <div className='doctor-extra-infor'>
                                                <DoctorExtraInfo
                                                    doctorIdFromParent={item}
                                                />
                                            </div>

                                        </div>
                                    </div>

                                )
                            })}
                    </div>
                </div>

            </>

        );
    }
}

const mapStateToProps = state => {
    return {
        language: state.app.language,

    };
};

const mapDispatchToProps = dispatch => {
    return {


    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailClinic);
